import { connect } from 'react-redux'
import FeedItemSearchPage from '../components/FeedItemSearchPage'

import { actionCreators as activityFeedActionCreators } from '@app/components/ActivityFeed/modules/activityFeed'

export default connect(
  null,
  activityFeedActionCreators,
)(FeedItemSearchPage)
